import { AxiosError } from 'axios';
import instance from '../config/axios';
import { BulkEmailResult } from '../interface/interface';

export async function fetchAllPostmarkEmailTemplates(
  token: string,
): Promise<number | Array<BulkEmailResult>> {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/fetch/all/postmark-template`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response!.status;
  }
}
